import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import LoanFeasibilityPageUI from './LoanFeasibilityPageUI.js'

class LoanFeasibilityPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loan: null,
      errorList: null,
      loanFeasibility: null,
      feasibilityItemList: [],
      provisionalYear: null,
      showAllYears: false,
      internalRemarksMode: false,
      externalRemarksMode: false,
      objectId: null,
      selectedRemarks: null,
      showDetailsMode: false,
      editable: false
    }
  }

  render() {
    return (
      <LoanFeasibilityPageUI
        context={this.props.context}
        loan={this.state.loan}
        account={this.state.account}
        errorList={this.state.errorList}
        loanFeasibility={this.state.loanFeasibility}
        feasibilityItemList={this.state.feasibilityItemList}
        provisionalYear={this.state.provisionalYear}
        onRefreshClick={this.onRefreshClick}
        showAllYears={this.state.showAllYears}
        onShowAllClick={() => { this.setState({ showAllYears: true }) }}
        onShowRecentClick={() => { this.setState({ showAllYears: false }) }}
        showDetailsMode={this.state.showDetailsMode}
        onShowDetails={this.onShowDetails}
        // internal
        onInternalRemarksClick={this.onInternalRemarksClick}
        internalRemarksMode={this.state.internalRemarksMode}
        // external
        onExternalRemarksClick={this.onExternalRemarksClick}
        externalRemarksMode={this.state.externalRemarksMode}
        // common
        onCancelRemarksClick={() => { this.setState({ internalRemarksMode: false, externalRemarksMode: false }) }}
        objectId={this.state.objectId}
        selectedRemarks={this.state.selectedRemarks}
        //
        toggleEditable={() => { this.setState({ editable: !this.state.editable }) }}
        editable={this.state.editable}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getLoanFeasibility(context)
  }

  getLoanFeasibility(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/feasibility`,
      cacheKey: CacheKeys.LoanFeasibility(this.props.match.params.loanId),
      callback: this.getLoanFeasibilityCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanFeasibilityCallback = (response) => {
    this.setState({
      loanFeasibility: response,
      feasibilityItemList: response.feasibilityItemList,
      errorList: response.errorList,
    })
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    let context = this.props.context
    this.setState({ errorList: response.errorList, loan: response.loan })
    this.getAccount(context, response.loan.accountId)
  }

  getAccount(context, accountId) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${accountId}`,
      cacheKey: CacheKeys.Account(accountId),
      callback: this.getAccountCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getAccountCallback = (response) => {
    this.setState({ account: response.account })
  }

  onInternalRemarksClick = (event) => {
    let objectId = event.currentTarget.getAttribute('data-object-id')
    this.setState({
      internalRemarksMode: true,
      objectId: objectId,
      selectedRemarks: this.state.loanFeasibility[objectId + 'InternalRemarks'] || ''
    })
  }

  onExternalRemarksClick = (event) => {
    let objectId = event.currentTarget.getAttribute('data-object-id')
    this.setState({
      externalRemarksMode: true,
      objectId: objectId,
      selectedRemarks: this.state.loanFeasibility[objectId + 'ExternalRemarks'] || ''
    })
  }

  onShowDetails = () => {
    if (this.state.showDetailsMode)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      showDetailsMode: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/scoreParameters/provisionals`,
      this.onShowDetailsCallback, {}
    )
  }

  onShowDetailsCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      showDetailsMode: false
    })

    if (response.errorList.length === 0) {
      this.getScoreParameters(this.props.context)
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
      }, 2000)
    }
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.LoanFeasibility(this.props.match.params.loanId))
    if (noBusy === 'noBusy')
      this.getLoanFeasibility(this.props.context)
    else
      this.setState({ loanFeasibility: null },
        () => {
          this.getLoanFeasibility(this.props.context)
        }
      )
  }
}

export default withRouter(LoanFeasibilityPageSF)
